/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { SkelletonLoader } from "components/CustomTableList/components/TableListItem/styles";
//#endregion
//#region Components
import CustomTableListWithDetails from "components/CustomTableList/CustomTableListWithDetails";
import TableListItemHeader from "./components/TableListItemHeader/TableListItemHeader";
import TableListItemDetails from "./components/TableListItemDetails/TableListItemDetails";
//#endregion
//#region Utils
import { HEADERS_TABLE_LIST } from "views/Configuracion/SettingsPenaltyAdmin/utils/constants";
//#endregion

const PenalizedStudentsTableList = ({
    loadingRequest, 
    idOfPenaltyToBeOpenedAfterAfterPerforingTheAction,
    studentPenaltyList, actions,
    currentTabIdx
}) => {
    //#region States
    const [detailsOfStudentPenaltiesAreOpened, setDetailsOfStudentPenaltiesAreOpened] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!idOfPenaltyToBeOpenedAfterAfterPerforingTheAction.value) return;
        openDetailsOfStudentPenalty(idOfPenaltyToBeOpenedAfterAfterPerforingTheAction.value, true);
        idOfPenaltyToBeOpenedAfterAfterPerforingTheAction.set(0);
    }, [idOfPenaltyToBeOpenedAfterAfterPerforingTheAction.value]);
    useEffect(() => {
        if (!studentPenaltyList.value) return;
        setDetailsOfStudentPenaltiesAreOpened(
            studentPenaltyList.value
            .map(({ id }) => ({
                penaltyId: id,
                opened: false
            })));
    }, [studentPenaltyList.value]);
    //#endregion
    //#region Functions
    const openDetailsOfStudentPenalty = (penaltyId, opened = null) => {
        setDetailsOfStudentPenaltiesAreOpened(prev => (
            prev.map(details => (
                details.penaltyId === penaltyId 
                ? { 
                    ...details, 
                    opened: opened === null ? !details.opened : opened  
                } : details
            ))
        ));
    }
    const getDetailOfStudentPenaltyIsOpened = penaltyId => {
        return detailsOfStudentPenaltiesAreOpened.find(details => details.penaltyId === penaltyId)?.opened;
    }
    const renderContentWhenNoContent = () => {
        if (!loadingRequest.value.hidden)
            return (
                Array(4).fill(0).map((_, idx) => (
                    <SkelletonLoader key={idx}>
                        {HEADERS_TABLE_LIST.map((_, idx2) => (
                            <td key={idx2}>
                                <div></div>
                            </td>
                        ))}
                    </SkelletonLoader>
                ))
            );
        if (!studentPenaltyList.value)
            return null;
    }
    //#endregion
    return (
        <CustomTableListWithDetails
            props={{ headers: HEADERS_TABLE_LIST }}
            data={studentPenaltyList.value}
            renderDetails={(item, idx) => (
                <TableListItemDetails 
                    key={idx} 
                    item={item}
                    detailsOfStudentPenaltyIsOpened={getDetailOfStudentPenaltyIsOpened(item.id)}
                    actions={actions}
                    currentTabIdx={currentTabIdx}/>
            )}
            renderHeader={(item, idx) => (
                <TableListItemHeader 
                    key={idx} 
                    item={item}
                    detailsOfStudentPenaltyIsOpened={getDetailOfStudentPenaltyIsOpened(item.id)}
                    toggleDetailsOfStudentPenaltyIsOpened={() => openDetailsOfStudentPenalty(item.id)}/>
            )}>
            {renderContentWhenNoContent()}
        </CustomTableListWithDetails>
    );
}

export default PenalizedStudentsTableList;